import { render } from "./AppSplashLayout.vue?vue&type=template&id=3754f887&scoped=true"
import script from "./AppSplashLayout.vue?vue&type=script&lang=js"
export * from "./AppSplashLayout.vue?vue&type=script&lang=js"

import "./AppSplashLayout.vue?vue&type=style&index=0&id=3754f887&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3754f887"]])

export default __exports__